import React, { useState, useEffect } from "react";
import { useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import Button from "../components/ds/Button";
import Checkbox from "../components/ds/Checkbox";
import Icon from "../components/ds/Icon";
import Message from "../components/ds/Message";
import Modal from "../components/ds/Modal";
import Overlay from "../components/ds/Overlay";
import RowPost from "../components/RowPost";
import TableFooter from "../components/TableFooter";
import { massiveSelect } from "../modules/table";
import { postService } from '../container';
import { useGlobalState } from '../state';

export default function Posts() {
  const { media } = useGlobalState();
  const [searchParams] = useSearchParams();
  const [massiveRemove, setMassiveRemove] = useState(false);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadPosts = async (filters) => {
    setLoading(true);

    try {
      const posts = await postService.search({
        media_id: media.id,
        ...filters,
      });

      setPosts(posts.filter((post) => !post.deleted_at));
    } catch (err) {
      toast.error('Ocurrió un error al cargar los posts.');
      console.error(err);
    }

    setLoading(false);
  };

  useEffect(() => {
    const filters = {
      title: searchParams.get('title'),
      category_id: searchParams.get('category_id'),
      state: searchParams.get('state'),
      author_id: searchParams.get('author_id'),
      date_from: searchParams.get('date_from'),
      date_to: searchParams.get('date_to'),
      order_by: searchParams.get('order_by'),
    };

    loadPosts(filters);
  }, [searchParams, media]);

  const viewPost = (post) => {
    window.open(`${media.base_path}${post.slug}`, '_blank');
  };

  const unpublishPost = async (post) => {
    try {
      await postService.unpublish(post.id);

      loadPosts();
    } catch (err) {
      toast.error('Ocurrió un error al despublicar el post.');
      console.error(err);
    }
  };

  const pinToHome = async (post) => {
    try {
      await postService.pinToHome(post.id);

      loadPosts();
    } catch (err) {
      toast.error('Ocurrió un error al anclar el post.');
      console.error(err);
    }
  };

  const unpinFromHome = async (post) => {
    try {
      await postService.unpinFromHome(post.id);

      loadPosts();
    } catch (err) {
      toast.error('Ocurrió un error al desanclar el post.');
      console.error(err);
    }
  };

  const deletePost = async (post) => {
    try {
      await postService.delete(post.id);

      loadPosts();
    } catch (err) {
      toast.error('Ocurrió un error al eliminar el post.');
      console.error(err);
    }
  };


  if (loading) {
    return <span>Loading...</span>;
  }

  return (
    <>
      <h1 className="t-heading-xl-cms">Posts</h1>

      <div id="content">
        <div className="table">
          <div className="head">
              <div className="row">
                <div className="col-5">
                  <Checkbox onchange={massiveSelect} />
                  <p>Título</p>
                </div>

                <div className="col-2">
                  <p>Sección</p>
                </div>

                <div className="col-2">
                  <p>Autor</p>
                </div>

                <div className="col-2">
                  <p>Estado</p>
                </div>
              </div>
          </div>

          <div className="body">
            {posts.map((post) => (
              <RowPost
                key={post.id}
                post={post}
                onView={viewPost}
                onUnpublish={unpublishPost}
                onPinToHome={pinToHome}
                onUnpinFromHome={unpinFromHome}
                onDelete={deletePost}
              />
            ))}
          </div>

          <TableFooter total={posts.length}>
            <li onClick={() => setMassiveRemove(true)}><Icon icon="trash" />Eliminar</li>
          </TableFooter>
        </div>
      </div>

      {massiveRemove && (
        <Overlay>
          <Modal title="Eliminar posts" onclose={() => setMassiveRemove(false)}>
            <Message type="warning" description={`Seguro que quieres eliminar estos posts? Esta acción no se puede deshacer.`} />

            <Button type="destructive" label="Eliminar" onclick={() => {}} />
          </Modal>
        </Overlay>
      )}
    </>
  )
}
